import React, { useState } from 'react';
import './App.css';
import RegistrationForm from './components/Registration/RegistrationForm';
import VisitorsList from './components/CurrentVisitors/VisitorsList';
import HistoryList from './components/History/HistoryList';
import PinLogin from './components/Auth/PinLogin';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function AppContent() {
  const [currentPage, setCurrentPage] = useState('current');
  const { isAuthenticated, isLoading } = useAuth();

  const renderPage = () => {
    switch (currentPage) {
      case 'registration':
        return <RegistrationForm onSuccess={() => setCurrentPage('current')} />;
      case 'current':
        return <VisitorsList />;
      case 'history':
        return <HistoryList />;
      default:
        return <VisitorsList />;
    }
  };

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
          Laddar...
        </div>
      </div>
    );
  }

  // Show PIN login if not authenticated
  if (!isAuthenticated) {
    return <PinLogin />;
  }

  // Show main app if authenticated
  return (
    <div className="App">
      <header className="App-header">
        <img
          src="/assets/images/lantmannen-logo.png"
          alt="Lantmännen Besöksregistrering"
          className="App-logo"
        />
        <nav className="App-nav">
          <button
            className={currentPage === 'registration' ? 'active' : ''}
            onClick={() => setCurrentPage('registration')}
          >
            Registrera
          </button>
          <button
            className={currentPage === 'current' ? 'active' : ''}
            onClick={() => setCurrentPage('current')}
          >
            Gäster
          </button>
          <button
            className={currentPage === 'history' ? 'active' : ''}
            onClick={() => setCurrentPage('history')}
          >
            Historik
          </button>
        </nav>
      </header>
      <main className="App-main">
        {renderPage()}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;